import { SET_LEAD_VALUATION_REQUEST } from '../../../Manage_retail/redux/constants/assign_lead.constants';

export const setLeadValuationRequest = (_id, valuation, description, suggested_margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade) => ({
    type: SET_LEAD_VALUATION_REQUEST, _id, valuation, description, suggested_margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/set_lead_valuation.actions.js